import { useEffect, useRef, useState } from "react";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Header from "../components/Header"; // Replace this with your Header component
import Footer from "../components/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import axiosInstance, { Homeurl,keyLogin, weburl } from "../../axiosInstance";


// import required modules
import { Pagination, Navigation } from "swiper/modules";
import RangeSlider from "../components/extra/RangeSlider";
import { Helmet } from "react-helmet";
import CreateSlug from "../components/extra/CreateSlug";
import { encrypt } from "../../helper/encryption";
import setCookie from "../../helper/setCookie";
import getDecryptData from "../../helper/getDecryptData";

const Category = () => {
  const loader = useRef(null);

  function formatBreadcrumb(text) {
  return text
    .replace(/-/g, ' ')                   // Replace hyphens with spaces
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word
}


  const { Headers, isHeader } = useBlogContext();

  const navigate = useNavigate();

  const [enquireData, setEnquireData] = useState([]);

  const [layout, setLayout] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isProducts, setIsProducts] = useState(true);

  const [RProducts, setRProducts] = useState([]);

  const [OTPVerify, setOTPVerify] = useState(false);
  const [GetOtpRes, setOtpRes] = useState(null);
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [ExistingUser, setExistingUser] = useState([]);

  const [AdsData, setAdsData] = useState([]);

        const verifyOTPFinal = async () => {
          setSubmitLoading(false); // Set loading to false after request completion
      
          const MYOTPinputs = { OTP: enquireData.otp, HASHOTP: GetOtpRes.otp }
      
          try {
            const response = await axiosInstance.post(`/login-verify-otp`, MYOTPinputs); // Await the axios post request
            console.log('responseresponse', response)
            const { success } = response.data
            if (success) {
      
              setOTPVerify(true);
      
            }
          } catch (error) {
            console.error('Error On OTP Verify:', error);
            toast.error(error.response.data.message);
            setOTPVerify(false);
  
          } finally {
            setSubmitLoading(true); // Set loading to false after request completion
          }
       
        }
        const ChangePhone = async () => {
          setOTPVerify(false);
          setOtpRes(null);
          setEnquireData((prevData) => ({
            ...prevData,
            otp: null,
          })); // Clear form fields

        }

    const submitOTP = async (phone) => {
      if (!phone) {
        toast.error('Please Enter a phone number.');
        return null;

      } else if (phone.length !== 10) {
        toast.error('Please Enter a 10-digit phone number.');
        return null;
      }  
      setSubmitLoading(false); // Set loading to true before making the request
      const inputs = {
        phone:phone
      }
      setOtpRes(null);
      try {
        const response = await axiosInstance.post(`/signup-login-new/`, inputs); // Await the axios post request
        console.log('responseresponse', response)
        setOtpRes(response.data); // Set the response data to state
        // console.log('dataotp', response.data.password);
        const { existingUser} = response.data;
        if(existingUser){
          setExistingUser(existingUser);
        }

      } catch (error) {
        console.error('Error On taxes:', error);
        toast.error(error.response.data.message);
      } finally {
        setSubmitLoading(true); // Set loading to false after request completion
      }
    };

  
  const getProducts = async () => {
        const decryptdatajson = await getDecryptData();
        if (decryptdatajson && decryptdatajson?._id) {
 
          setEnquireData((prevData) => ({
            ...prevData,
            fullname: decryptdatajson.username,
            email: decryptdatajson.email,
            phone: decryptdatajson.phone,

          })); // Clear form fields
          setOtpRes(true);
          setEnquireData((prevData) => ({
            ...prevData,
            otp: null,
          })); // Clear form fields

          setOTPVerify(true);

        }

    try {
      const { data } = await axiosInstance.get("/all-home-products");
      setRProducts(data.products);
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };

  const getData = async () => {
    try {
      const { data } = await axiosInstance.get(`/home-layout-data`);
      setLayout(data.homeLayout);
      setIsLoading(false); // Set loading state to false in case of an error
    } catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    if(location === locSlug){
    getData();
    getProducts();
      }

  }, []);

  const startMin = 0;
  const startMax = 100;
  const min = 0;
  const max = 200;
  const step = 1;

  const [selectedRanges, setSelectedRanges] = useState([]);

  const [selectedFilters, setSelectedFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [Cat, setCat] = useState([]);
  const [CatT, setTCat] = useState([]);
  const [CatImage, setTCatImage] = useState("");

  const [CatM, setMCat] = useState([]);

  const [Pro, setPro] = useState([]);
  const [Attr, setAttr] = useState([]);
  const [fillter, setfillter] = useState("");

  const [Viewfillter, setViewfillter] = useState([]);

  const [isCat, setIsCat] = useState(true);
  const [count, setcount] = useState("100");
  const [Sidebar, setIsSidebar] = useState(false);

  const handlecountChange = (event) => {
    setcount(event.target.value);
  };

  const { id ,location} = useParams();


      const locationData = localStorage.getItem('location');
const locSlug = locationData ? CreateSlug(locationData) : null;


  const capLocation = location?.charAt(0).toUpperCase() + location?.slice(1);
   const capitalizedLocation = capLocation.replaceAll('-', ' ');
 
  const [products, setProducts] = useState([]);
  const [ratings, setRatings] = useState([]);

  const getRating = async () => {
    try {
      const { data } = await axiosInstance.get(`/all-rating`);
      setRatings(data.ratings);
      // console.log('getRating', data)
    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };

  const [Specifications, setspecifications] = useState([]);

  const getCategory = async (fillter, page, price) => {
    setIsSidebar(false);
    if (window.__PRELOADED_DATA__?.MainCat?.slug !== id || window.__PRELOADED_DATA__ === undefined) {
      try {
        window.scrollTo(0, 0);
        setIsCat(true);
        const encodedFilter = encodeURIComponent(fillter); // Encode the filter string
         const { data } = await axiosInstance.get(
          `/all/category-slug/${id}?filter=${encodedFilter}&price=${price}&page=${page}&perPage=${count}&location=${location}`
        );

        setCat([]);
        setTCat([]);
        setMCat([]);
        if (data?.success) {
          setCat(data?.categories);
          setTCat(data.MainCat);
          console.log("data.MainCat", data.MainCat);
          setEnquireData((prevData) => ({
            ...prevData,
            service: data.MainCat?.title,
            category: data.MainCat?.title,
          })); // Clear form fields
         
          setAdsData((prevData) => ({
          ...prevData,
            adsImage: data.adsImage,
            adsImageLink: data.adsImageLink,
            thumbnail: data.thumbnail,
          })); // Clear form fields

          setspecifications(data.MainCat.specifications.specifications || []);

          setTCatImage(data.MainCat.image);
          setTotalPages(data?.proLength);
          setfillter(fillter);

          setProducts(data?.productsFilter);
         console.log('setProducts',data?.productsFilter)
          setPro(data?.products);
          setMCat(data?.MainCat);
        }

        // console.log('datadatadata', data)
      } catch (error) {
        console.log(error);
        toast.error("Error fetching Category!");
        navigate("/404");
        
      } finally {
        setIsCat(false);
      }
    } else {

      setCat([]);
      setTCat([]);
      setMCat([]);

      setCat(window.__PRELOADED_DATA__?.categories);
      setTCat(window.__PRELOADED_DATA__.MainCat);
      console.log("data.MainCat", window.__PRELOADED_DATA__.MainCat);
      setEnquireData((prevData) => ({
        ...prevData,
        service: window.__PRELOADED_DATA__.MainCat?.title,
      })); // Clear form fields
      setspecifications(window.__PRELOADED_DATA__.MainCat.specifications.specifications || []);

      setTCatImage(window.__PRELOADED_DATA__.MainCat.image);
      setTotalPages(window.__PRELOADED_DATA__?.proLength);
      setfillter(fillter);

      setProducts(window.__PRELOADED_DATA__?.productsFilter);

      setPro(window.__PRELOADED_DATA__?.products);
      setMCat(window.__PRELOADED_DATA__?.MainCat);

      setIsCat(false);

    };
  };

  const Opensidebar = async () => {
    setIsSidebar(true);
  };
  const Closesidebar = async () => {
    setIsSidebar(false);
  };

  const getAttribute = async () => {
    try {
      const { data } = await axiosInstance.get("/all-attribute");
      // console.log("attr", data);
      setAttr(data.Attribute);
    } catch (error) {
      console.error("Error fetching attributes:", error);
    }
  };

    // Function to handle checkbox selection
    const handleCheckboxChange = (event) => {
      const { value, checked } = event.target;
      // console.log('valuevaluevalue', value)
      setSelectedFilters((prevState) => {
        // If checked, add the value to selectedFilters, otherwise remove it
        if (checked) {
          return { ...prevState, [value]: checked };
        } else {
          const { [value]: removedValue, ...rest } = prevState;
          return rest;
        }
      });
  
      // console.log('selectedFilters', selectedFilters)
      setCurrentPage(1);
    };

  // Function to handle checkbox selection
  const handleCheckboxChangeOld = (event) => {
    const { value, checked } = event.target;
    const [attrName, attrValue] = value.split(",");
  
    setSelectedFilters((prevFilters) => {
      const existing = prevFilters[attrName]?.split(",") || [];
  
      const updated = checked
        ? [...new Set([...existing, attrValue])] // Add unique
        : existing.filter((v) => v !== attrValue); // Remove unchecked
  
      if (updated.length === 0) {
        const { [attrName]: removed, ...rest } = prevFilters;
        return rest;
      }
  
      return {
        ...prevFilters,
        [attrName]: updated.join(","),
      };
    });
  
    setCurrentPage(1);
  };
  

  const removeFilter = ({ key, val }) => {
    const value = `${key},${val}`;
    setSelectedFilters((prevState) => {
      const { [value]: removedValue, ...rest } = prevState;
      return rest;
    });

    setCurrentPage(1); // Set current page to 1
  };

  const generateQueryString = () => {
    const filterObj = {};

    // Construct filter object from selected filters
    Object.entries(selectedFilters).forEach(([key, value]) => {
      const [attrKey, attrValue] = key.split(",");

      // Check if attribute key already exists in filter object
      if (filterObj[attrKey]) {
        // Append to existing attribute value if key exists
        filterObj[attrKey] += `,${attrValue}`;
      } else {
        // Create new attribute if key doesn't exist
        filterObj[attrKey] = attrValue;
      }
    });

    // Convert filter object to JSON string
    const filterString = JSON.stringify(filterObj);

    // console.log(filterString); // Output the generated filter string
    setViewfillter(filterString);
    setTimeout(function () {
      getCategory(filterString, currentPage, selectedRanges);
    }, 100);
  };

  // const handleCategoryLinkClick = (categoryId) => {
  //   getCategory(fillter, currentPage, selectedRanges);
  // };

  useEffect(() => {
        if(location === locSlug){

    generateQueryString(); // Call generateQueryString when selectedFilters change
    getRating();
    setIsCat(true); // Set loading state to true
    getAttribute();
        }
        
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
         
           setEnquireData((prevData) => ({
            ...prevData,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          })); // Clear form fields

          console.log("Latitude:", position.coords.latitude);
          console.log("Longitude:", position.coords.longitude);
        },
        
      );
    } else {
      toast.error('Geolocation is not supported by this browser.');
      return null;
     }


    // getCategory(fillter,currentPage,selectedRanges);
  }, [id, currentPage, selectedFilters, selectedRanges, count,location]); // Empty dependency array ensures that the effect runs once after the initial render

  useEffect(() => {
    setSelectedRanges([]);


  }, [id]); // Empty dependency array ensures that the effect runs once after the initial render

  // useEffect(() => {
  //   generateQueryString(); // Call generateQueryString when selectedFilters change
  // }, [selectedFilters,selectedRanges]); // Add selectedFilters as a dependency

  // Function to filter products based on selected attributes

  const [priceRange, setPriceRange] = useState({ min: 0, max: 100 });

  function handleChange(e) {
    setPriceRange({
      priceRange,
      [e.target.name]: parseInt(e.target.value),
    });
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Calculate the maximum sale price to determine the range
  const maxSalePrice = Math.max(
    ...products.map((product) => product.salePrice)
  );

  // Determine the number of ranges based on the maximum sale price
  const numRanges = Math.ceil(maxSalePrice / 10000);

  // Generate price ranges dynamically
  const priceRanges = Array.from({ length: numRanges }, (_, index) => ({
    min: index * 10000,
    max: (index + 1) * 10000,
  }));

  // Filter out the price ranges that match the actual sale prices of your products
  const filteredPriceRanges = priceRanges.filter((range) =>
    products.some(
      (product) =>
        product.salePrice >= range.min && product.salePrice < range.max
    )
  );

  const handleCheckpriceboxChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setSelectedRanges([...selectedRanges, value]);
    } else {
      setSelectedRanges(selectedRanges.filter((range) => range !== value));
    }
    setCurrentPage(1);
    // console.log(selectedRanges)
  };

  const addedVariations = new Set();


   const [loading, setLoading] = useState(true); // Add loading state
 
  const [EnquireShow, setEnquireShow] = useState(false);

  const [EnquireStatus, setEnquireStatus] = useState(false);

  const [StepForm, setStepForm] = useState(0);
  

   const [data, setData] = useState([]);
    const [filteredCities, setFilteredCities] = useState([]);
  
  
   
     const fetchData = async () => {
      setLoading(true);
      console.log("response.data start");
  
      try {
        const response = await axiosInstance.get("/get-all-zones");
        console.log("response.data.Zones,", response.data.Zones);
        setData(response.data.Zones);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      fetchData();

      
  if(location !== locSlug){
   // navigate("/404");
  console.log('myloccc', location,locSlug)
  navigate(`/${locSlug}/${id}`);

  }
 
    }, []); // Empty dependency array ensures that the effect runs once after the initial render
  

  const handleNext = () => {
    setStepForm((prevStep) => prevStep + 1);
  };

  const handlePrevious = () => {
    setStepForm((prevStep) => prevStep - 1);
  };



  const enquireToggle = () => {
    if (EnquireShow) {
      setEnquireShow(false);
    } else {
      setEnquireShow(true);
    }
  };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    str = str.replace(/\d+/g, "");
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const validate = (email) => {
    // Regular expression to check for invalid characters
    const invalidCharsRegex = /[^\w@_.]| /; // Disallow spaces and any character that's not a word character, @, or .

    // Check for invalid cases
    if (email === "-" || email === "+") {
      return "";
    } else if (invalidCharsRegex.test(email)) {
      return ""; // Return empty string if invalid characters (including spaces) are found
    } else {
      return email; // Return the original email if valid
    }
  };

  const handleEnquireChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Determine the new value based on input type
    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Capitalize each word for specific fields
    if (name === "fullname") {
      newValue = capitalizeEachWord(newValue);
    }

    if (name === "email") {
      newValue = validate(newValue);
    }

    if (name === "phone") {
      // Replace non-digit characters
      newValue = value.replace(/\D/g, ""); // This allows only digits

      // if (newValue.startsWith('0')) {
      //   newValue = newValue.slice(1); // Remove the first '0'
      // } 

      // Limit to 10 digits
      if (newValue.length > 13) {
        newValue = newValue.slice(0, 13); // Limit to 10 digits
      }
    }

  // Capitalize text for the 'username' field
  if (name === "state") {
    const selectedState = data.find((state) => state._id === newValue);
    if (selectedState) {
      setFilteredCities(selectedState.cities);
      setEnquireData((prevData) => ({
        ...prevData,
        statename: selectedState.name,
        city: "",
      }));
    }
    console.log("selectedState", selectedState, newValue, data);
  }


    // Update form data with the new value
    setEnquireData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const handleSendEnquire = async () => {
    const fields = [
      { name: "fullname", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      { name: "requirement", message: "Please enter requirement" },
    ];

    for (const field of fields) {
      if (!enquireData[field.name]) {
        toast.error(field.message);
        setEnquireStatus(false);
        return;
      }
    }
   


    try {
      setEnquireStatus(true);
    const  data = await toast.promise(axiosInstance.post(`/send-enquire-category`, enquireData), {
        loading: "Enquire Submiting...", // Loading message
        success: "Enquire Submited Successfully!", // Success message
        error: "Failed to Submit Enquire.", // Error message
      });

            const { success, user } = data.data;
              if (success) {
                if(user){
                  const { _id, username, email, type, phone } = user;
                  const userToStore = { _id, username, email, type, phone };
        
                  // Encrypt the user data and set a cookie
                  const encryptedData = encrypt(JSON.stringify(userToStore), keyLogin);
                  setCookie('token', encryptedData, 7); // Expires in 7 days
        
                }
             
                enquireToggle();
                setEnquireData((prevData) => ({
                  ...prevData,
                 
                  requirement: "",
                })); // Clear form fields

              } 

    
    } catch (error) {
      console.error("Failed to send email:", error);
    toast.error(error?.response?.data?.message);
    } finally {
      setEnquireStatus(false);
    }
  };

    useEffect(() => {
      if(OTPVerify && ExistingUser && ExistingUser._id){
        const { _id, username, email, type, phone } = ExistingUser;
          const userToStore = { _id, username, email, type, phone };
  
        // Encrypt the user data and set a cookie
        const encryptedData = encrypt(JSON.stringify(userToStore), keyLogin);
        setCookie('token', encryptedData, 7); // Expires in 7 days
  
        setTimeout(() => {
        
          window.location.reload(); // Corrected method to reload the page
        
        }, 500);
  
      }
    }, [OTPVerify]);


    
  // useEffect(() => {
  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       if (entries[0].isIntersecting) {
  //         setCurrentPage((prev) => prev + 1);
  //       }
  //     },
  //     { threshold: 1 }
  //   );

  //   if (loader.current) observer.observe(loader.current);
  //   return () => {
  //     if (loader.current) observer.unobserve(loader.current);
  //   };
  // }, []);

  return (
    <>
 
      <Header title={formatBreadcrumb(id)} />

      <div className="bg-white">
        {/* Page Title */}
        {/* <div
          className="py-4 mb-4 mb-lg-0 white"
          style={{ backgroundColor: "whitesmoke" }}
        >
          <div className="container d-lg-flex justify-content-between align-items-center py-2 py-lg-4">
            <div className="pe-lg-4 text-center text-lg-start">
              <h1 className="h3 mb-0">
                {CatT ? <> {CatT.title} </> : <> </>} Category{" "}
              </h1>
            </div>
            <div className="pt-2 pt-lg-0">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb flex-lg-nowrap justify-content-center justify-content-lg-start">
                  <li className="breadcrumb-item">
                    <Link className="text-nowrap" to="/">
                      <i className="ri-store-2-line" /> Home{" "}
                    </Link>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div> */}
        {/* Page Title */}
        {/* Product Category */}
        <div className="container mt-4 pb-4 pb-lg-10">
          <div className="row g-md-4 ">
         
            {/* Content */}


            <aside className="col-md-12 " style={{ flex: 1 ,minHeight:'80vh'}}>

{(CatImage === undefined || CatImage === "") ? (
  <div
 className=" skeleton w-100 h-auto rounded border adsbannersize mb-3"
   style={{ aspectRatio:"1/0.1", objectFit: "cover" }}
  ></div> 
) : (
  AdsData.thumbnail ?
<button   data-bs-toggle="modal" data-bs-target="#videoModel" className="border-0 bg-transparent" >
  <img
    src={!AdsData.thumbnail ? `${weburl}${AdsData.adsImage}` : `${weburl}${AdsData.thumbnail}`}
     className="w-100 rounded border mb-3 adsbannersize"
    style={{
      aspectRatio: "1/0.1",
      objectFit: "cover",
    }}
    alt="Cat"
   onError={(e) => e.target.src = CatImage}
  />
  
</button> : 
<Link to={AdsData.adsImageLink ?? ''}   >
  <img
    src={!AdsData.thumbnail ? `${weburl}${AdsData.adsImage}` : `${weburl}${AdsData.thumbnail}`}
     className="w-100 rounded border mb-3 adsbannersize"
    style={{
      aspectRatio: "1/0.1",
      objectFit: "cover",
    }}
    alt="Cat"
   onError={(e) => e.target.src = CatImage}
  />
  
</Link>
  

)}
 
 {AdsData?.thumbnail && (
  <div
    className="modal fade"
    id="videoModel"
    tabIndex={-1}
    aria-labelledby="videoModelLabel"
    aria-hidden="true"
  >
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5" id="videoModelLabel">
            Video Ad
          </h1>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div className="modal-body">
          {/* Check if adsImage exists before rendering the video */}
          {AdsData.adsImage ? (
            <video width="100%" height="400" controls>
              <source src={`${weburl}${AdsData.adsImage}`} type="video/mp4" />
              <source src={`${weburl}${AdsData.adsImage}`} type="video/ogg" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <p>No video available.</p>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Close
          </button>
          <a  href={AdsData.adsImageLink ?? ''}     className="btn btn-primary">
            Visit Link
          </a>
        </div>
      </div>
    </div>
  </div>
)}

  

<nav aria-label="breadcrumb ">
  <ol class="breadcrumb mb-0 pb-0">
    <li class="breadcrumb-item text-capitalize"> {formatBreadcrumb(location) || 'home'} </li>
    <li class="breadcrumb-item  active text-capitalize"  aria-current="page" > {formatBreadcrumb(id) || 'category'} </li>
   </ol>
</nav>

              <div className="d-none">
  {CatImage !== undefined && CatImage !== "" ? (
                <>
                  <div
                    className="bg-image p-4"
                    style={{
                      backgroundImage: `url('${CatImage}'`,
                      aspectRatio: "5/1",
                    }}
                  >
                    <div className="row align-items-center">
                      <div className="col-md-8">
                      <h1 className="text-white">  {CatT.slide_head?.replace(/\$\{location\}/g, capitalizedLocation)}  </h1>
                      <p className="text-white">{CatT.slide_para?.replace(/\$\{location\}/g, capitalizedLocation)}</p>
                      </div>
                      <div className="col-md-4">
                          
 
              <div className=" bg-light p-4 border-bottom mb-2 border rounded " style={{boxShadow:'0px 0px 23px #00ffdd'}}>
                <h5
                  className="border-bottom pb-2"
                  style={{ textTransform: "uppercase" }}
                >
               ENQUIRE FOR {CatT ? <> {CatT.title} </> : <> </>} {" "}
                  <i className="ri-chat-3-fill"></i>
                </h5>
                {/* Name input */}
            
            <div className="row">
            <div   className="form-outline mb-4 col-6">
                  <label className="form-label" htmlFor="form5Example1">
                    Full Name <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="text"
                    name="fullname"
                    id="form5Example1"
                    className="form-control"
                    value={enquireData.fullname}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div   className="form-outline mb-4 col-6 ">
                  <label className="form-label" htmlFor="form5Example2">
                    Email ID <span className="text-danger"> (Required )</span>
                  </label>
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    name="email"
                    value={enquireData.email}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                </div>

            </div>
          
       

                <div className="mb-4 col-12">
                        <label className="form-label text-dark" htmlFor="name">
                          Phone <span className="text-danger"> ( Required )</span>
                        </label>
                        <div className=" d-flex gap-2  input-sm">
                          <input
                            type="number"
                            id="phone"
                            className={`form-control ${!OTPVerify && 'bg-white' }`}
                            name="phone"
                            value={enquireData.phone}
                            disabled={OTPVerify}
                            onChange={(e) => {
                              if (e.target.value.length <= 10 && !OTPVerify) {
                                // Check input length before updating
                                handleChange(e); // Call handleChange if length is within limit
                              }
                            }}
                            onInput={(e) => {
                              const inputValue = e.target.value;
                              if (inputValue.length <= 10 && !OTPVerify) {
                                setEnquireData({ ...enquireData, phone: inputValue });
                              }
                            }}
                          // onChange={() => {
                          //   handleChange();
                          // }}
                          />
                          {GetOtpRes && OTPVerify && 
                             <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={ChangePhone}>Edit</button>
                          }
                        {(GetOtpRes && !OTPVerify) ? 
   <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{submitOTP(enquireData.phone)}}>Resend OTP</button>
 : !OTPVerify && <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{submitOTP(enquireData.phone)}}>Send OTP</button>
  } 
                        </div>
                        {(GetOtpRes && !OTPVerify)  && 
                        <div className="mt-4 d-flex gap-2 col-8 border p-2 rounded w-100 bg-white">

                          <input
                          type="number"
                          id="otp"
                          className="form-control"
                          name="otp"
                          placeholder="Enter OTP"
                          value={enquireData.otp}
                          onChange={(e) => {
                            if (e.target.value.length <= 4) {
                              // Check input length before updating
                              handleChange(e); // Call handleChange if length is within limit
                            }
                          }}
                          onInput={(e) => {
                            const inputValue = e.target.value;
                            if (inputValue.length <= 4) {
                              setEnquireData({ ...enquireData, otp: inputValue });
                            }
                          }}
                        
                        />
                           <button class="btn btn-primary btn-md w-auto rounded-xl" type="button" onClick={()=>{verifyOTPFinal()}}>Verify</button>

                        </div>
                         }
                      </div>


                

             
                <div data-mdb-input-init="" className="form-outline mb-4 ">
                  <label className="form-label" htmlFor="form5Example2">
                    Requirement{" "}
                    <span className="text-danger"> (Required )</span>
                  </label>
                  <textarea
                     id="requirement"
                    className="form-control"
                    name="requirement"
                    value={enquireData.requirement}
                    onChange={handleEnquireChange}
                    style={{ boxShadow: "none" }}
                  />
                  <input
                    type="text"
                    id="service"
                    value={enquireData?.service}
                    className="form-control d-none"
                    style={{ boxShadow: "none" }}
                  />
                </div>

                <div
                  className="d-block"
                  style={{ width: "fit-content !important" }}
                >
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                    onClick={handleSendEnquire}
                    disabled={EnquireStatus} // Properly use the `disabled` attribute
                  >
                    Submit
                  </button>
                </div>


              </div>

              <div  
                className={`offcanvas offcanvas-collapse offcanvas-start d-none rounded-3 shadow ${Sidebar && "show"
                  }`}
                id="category-sidebar"
                style={{ maxWidth: "23rem" }}
              >
                <div className="offcanvas-header align-items-center shadow-sm d-none">
                  <h2 className="h5 mb-0">Filters</h2>
                  <button
                    className="btn-close ms-auto"
                    type="button"
                    onClick={Closesidebar}
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  />
                </div>

                {CatT.filter !== 0 && (
                  <div className="offcanvas-body p-lg-8 ">
                    {/* Categories */}
                    <div className="widget widget-categories pb-5 mb-5 ">
                      {/* Price Range Slider */}
                      <div className="widget pb-5 mb-5">
                        <h2>Filtered Products</h2>
                        {/* <ul>
          {filteredProducts.map(product => (
            <li key={product._id}>
              <img src={product.pImage} alt={product.title} />
              <p>{product.title}</p>
              <p>{`Sale Price: $${product.salePrice}`}</p>
            </li>
          ))}
        </ul>
 */}

                        {/* <h3 className="widget-title">Price</h3> */}
                        {filteredPriceRanges &&
                          filteredPriceRanges.length > 0 && <b>Price</b>}
                        <ul className="widget-list pt-1">
                          {filteredPriceRanges.map((range, index) => {
                            const isChecked = selectedRanges.includes(
                              `${range.min}-${range.max}`
                            );
                            return (
                              <li key={index} className="mb-1">
                                <div className="form-check">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id={`checkbox-${index}`}
                                    value={`${range.min}-${range.max}`}
                                    onChange={handleCheckpriceboxChange}
                                    checked={isChecked}
                                  />
                                  <label
                                    className="form-check-label"
                                    htmlFor={`checkbox-${index}`}
                                  >
                                    ₹{range.min} - ₹{range.max}
                                  </label>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                      {/* Price Range Slider */}
                      {/* <h3 className="widget-title">Categories</h3> */}

                      {/* Product category */}
{Attr.length} <br/>
{products.length}

{products.map((product) => (
  <div key={product._id}>
    <strong>Product:</strong> {product.slug}
    <ul>
      {product.variations?.map((variation, index) => (
        <li key={index}>{variation.name}</li>
      ))}
    </ul>
  </div>
))}

 

{Attr.map((attr, index) => {
  const hasVariations = products.some(
    (product) =>
      product.variations &&
      product.variations.some((variation) => variation.name === attr.name)
  );

  if (hasVariations) {
    return (
      <div className="accordion-item" key={attr._id}>
        <h2 className="accordion-header" id={`heading${index + 1}`}>
          <button
            className="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#collapse${index + 1}`}
            aria-expanded="true"
            aria-controls={`collapse${index + 1}`}
          >
            {attr.name}
          </button>
        </h2>
        <div
          id={`collapse${index + 1}`}
          className="accordion-collapse collapse show"
          aria-labelledby={`heading${index + 1}`}
          data-bs-parent="#accordionExample"
        >
          <div className="accordion-body">
            <ul className="widget-list pt-1">
              {attr.value.map((val, valIndex) => (
                <li className="mb-1" key={`${attr._id}-${valIndex}`}>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value={`${attr.name},${val}`}
                      onChange={handleCheckboxChange}
                      id={`checkbox-${valIndex}${attr._id}`}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`checkbox-${valIndex}${attr._id}`}
                    >
                      {val}
                    </label>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  }

  return null;
})}


                    </div>
                    {/* Categories */}
                  </div>
                )}
              </div>
       
            {/* Sidebar */}
                      </div>
                    </div>
                 
                  </div>{" "}
                </>
              ) : (
                <div
                  className=" skeleton w-100 h-auto"
                  style={{ aspectRatio: "5/1", objectFit: "cover" }}
                />
              )}
              </div>
            

              <div className="row ">
                {isCat
                  ? Array.from({ length: 4 }).map((_, index) => (
                    <div className="col-md-2 col-6 mt-4">
                      <div
                        className="card-1 skeleton mb-2"
                        style={{ height: 200, borderRadius: 10 }}
                      ></div>
                    </div>
                  ))
                  : Cat.length > 0 &&
                  Cat.map((Cat) => (
                    <>
                      <div className="col-md-2 col-6 mt-4">
                        <div className="p-0 bg-white rounded">
                          <Link className="col py-2 " to={`/${Cat.slug}`}>
                            <img
                              alt="ICU At Home"
                              width="100%"
                              className="rounded"
                              src={Cat.image}
                              style={{
                                width: "100%",
                                objectFit: "cover",
                                aspectRatio: "1 / 1",
                              }}
                            />
                            <h5 className="text-center text-primary fs-lg px-2 py-2">
                              {" "}
                              {Cat.title}{" "}
                            </h5>
                          </Link>
                        </div>
                      </div>
                    </>
                  ))}
              </div>
              {/* Recommended Products Slider */}
              {/* Toolbar */}
              {CatT.filter !== 0 && (
                <div
                  className="card mt-5 mb-4  d-none"
                  style={{ backgroundColor: "#e2f0f0",width:'max-content',marginLeft:'auto' }}
                >
                  <div className=" px-3   rounded border">
                    <div className="card-body py-2 m " >
                      <div className="d-flex align-items-center justify-content-between">
                        <form className="row row-cols-auto g-4 align-items-center me-3">
                          <div className="col">
                            <div className="row g-2">
                              <label
                                htmlFor="sorting"
                                className="col-auto col-form-label d-sm-block"
                              >
                                No of products
                              </label>
                              <div className="col-auto">
                                <select
                                  className="form-select"
                                  id="sorting"
                                  value={count}
                                  onChange={handlecountChange}
                                >
                                  <option value="50">50</option>
                                  <option value="100">100</option>

                                  <option value="200">200</option>

                                  <option value="500">500</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </form>
                        <ul
                          className="nav nav-pills flex-nowrap"
                          id="pills-tab"
                          role="tablist"
                        >
                          <li
                            className="nav-item d-lg-none"
                            role="presentation"
                          >
                            <button
                              onClick={Opensidebar}
                              className="nav-link active py-2 px-3"
                              id="pills-home-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-home"
                              type="button"
                              role="tab"
                              aria-controls="pills-home"
                              aria-selected="true"
                            >
                              Fillter{" "}
                              <i className="ri-function-line fs-5 ms-2" />
                            </button>
                          </li>

                          {/* <li className="nav-item" role="presentation">
                        <button
                          className="nav-link py-2 px-3"
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          <i className="ri-list-check fs-5" />
                        </button>
                      </li> */}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              )}

{Attr.map((attr, index) => {
  const hasVariations = products.some(
    (product) =>
      product.variations &&
      product.variations.some((variation) => variation.name === attr.name)
  );

  // Parse the filters
  let parsedFilters = {};
  try {
    if (Viewfillter) {
      parsedFilters = JSON.parse(Viewfillter);
    }
  } catch (error) {
    console.error("Error parsing Viewfillter:", error);
  }

  // Check if there are any filters applied for this attribute
  const isFiltered = parsedFilters[attr.name];

  if (hasVariations) {
    return (
      <div className="d-block" key={attr._id}>
        <h4 className="m-0 mt-2">{attr.name}</h4>
        <hr className="w" />
        <div className="d-flex gap-2">
          {attr.value.map((val, valIndex) => {
            // Check if this value is checked in the current filter
            const isChecked = parsedFilters[attr.name]
              ?.split(",")
              .includes(val);

            return (
              <span className={`mb-1 ${isChecked ? 'bg-primary' : 'btn-outline-primary'}`} key={`${attr._id}-${valIndex}`}>
                <div className={`px-3 py-2 rounded ${isChecked ? 'text-white': 'text-dark'}`}>
                  <input
                    className="d-none"
                    type="checkbox"
                    value={`${attr.name},${val}`}
                    onChange={handleCheckboxChange}
                    id={`checkbox-${valIndex}${attr._id}`}
                   />
                  <label
                    className="form-check-label m-0 p-0" type="button"
                    htmlFor={`checkbox-${valIndex}${attr._id}`}
                  >
                    {val}
                  </label>
                </div>
              </span>
            );
          })}
        </div>
      </div>
    );
  }

  return null;
})}


              {/* Toolbar */}

              {/* {Viewfillter && (
                <div className="w-100">
                  {(() => {
                    try {
                      const parsedFilters = JSON.parse(Viewfillter);
                      return Object.entries(parsedFilters).map(
                        ([key, value]) => (
                          <span key={key} className="w-100">
                            {value.split(",").map((val) => (
                              <button
                                onClick={() => removeFilter({ key, val })}
                                className="btn btn-sm btn-secondary py-1 px-2 ms-1 mb-2"
                                key={`${key}-${val}`}
                              >
                                {`${key}: ${val}`} <i class="ri-close-line"></i>
                              </button>
                            ))}
                          </span>
                        )
                      );
                    } catch (error) {
                      console.error("Error parsing Viewfillter:", error);
                      return <div>No filters Found</div>;
                    }
                  })()}
                </div>
              )} */}

              {/* <h2 className="h3 border-bottom pb-4 mb-4">
                Results for   {CatT ? <>  {CatT}  </> : <> loading.. </>}
              </h2> */}

<div className="row">
  
   
 
                <div className="mt-4 col-md-10">

                  {/* Heading */}
   <div
                className={`tab-content ${CatT.filter === 0 && "d-none"}`}
                id="pills-tabContent"
              >
                {/* Product Grid */}
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  {/* Product Cards */}
                  <div className="row pt-2 mx-n2 mb-4 mb-sm-8 bg-white pb-4 rounded-4">
                    {isCat
                      ? Array.from({ length: 6 }).map((_, index) => (
                        <div
                          key={index}
                          className="col-lg-3 col-md-4 col-sm-6 mt-4"
                        >
                          <div
                            className="card-1 skeleton"
                            style={{ height: 430, borderRadius: 5 }}
                          ></div>
                        </div>
                      ))
                      : Pro.map((Pro) => {
                      
                        return (
                          <>
                            {/* Product */}
                            <div className=" col-md-12 px-2 mb-4">
                              <div className="card card-product h-100 bg-light border rounded-4 overflow-hidden bgw-white">
                             
                                {/* Badges */}
                                {/* Buttons */}
                                <div className="product-buttons">
                                  <button
                                    className="btn-product btn-wishlist"
                                    type="button"
                                    data-bs-toggle="button"
                                    title="Add to wishlist"
                                  >
                                    <i className="ri-heart-line" />
                                  </button>
                                  <Link
                                    className="btn-product btn-compare"
                                    href="#"
                                    title="Compare product"
                                  >
                                    <i className="ri-repeat-line" />
                                  </Link>
                                </div>
                                {/* Buttons */}
                                {/* Preview Image */}
                               
                                {/* Preview Image */}
                                <div className="card-body p-2 ">
                                  {/* Product Category */}

                  

                                  {/* Product Category */}
                                  {/* Product Title */}
                                    <div className="d-flex justify-content-between w-100 gap-4 p-0 m-0">
                                 
                                       <div className="col-md-2 col-6 ">
                                        <Link to={`/product/${Pro.slug}`}> 
                                        <img src={Pro.pImage} className="w-100 rounded" style={{aspectRatio:'1/1',objectFit:'cover'}} />
                                      </Link>
                                       </div>
                                       <div className="col">

                                  <h4 className="h4 fw-bold mt-2">
                                    <Link to={`/product/${Pro.slug}`}>
                                       {Pro.title} 
                                    </Link>
                                  </h4>


{Pro.salePrice === 0 ?
 <h5 className="h5 fw-bold mt-2 text-primary text-decoration-underline">
                                    Ask for price
                                  </h5> :
                                    <h5 className="h5 fw-bold mt-2">
                                     ₹{Pro.salePrice}   <del>
                                      ₹{Pro.regularPrice}
                                     </del>
                                  </h5>
} 
                                 


                                  <div className="bg-primary d-inline-block px-2 rounded text-white">
                                  <i className="ri-star-s-fill"></i>  4.8 
                                  </div>
                                  <div className="d-inline-block small ms-2 text-grey fw-light opacity-50" style={{fontWeight:'100'}}>
                                    206 Ratings
                                  </div>

                                  <p className="my-1">
                                   <i class="ri-map-pin-line "></i>  {Pro.userId.address || "NA"}
                                  </p>
                                  <p>
                                    {Pro.features.map((feature, index) => (
                                       <span key={index} class="badge text-bg-primary text-white me-2 d-md-inline d-none">{feature}</span>
                                                              ))}
                                       </p>

<div className="d-md-flex d-none gap-2">

    <Link   to={`tel:${Pro.userId.phone}`} className="btn btn-success rounded me-2 py-2" style={{backgroundColor:'#058a07'}}>
                                        <i className="ri-phone-fill me-2" />
                                          0{Pro.userId.phone}
                                        </Link>

                                        <Link target="_blank" to={`https://api.whatsapp.com/send/?phone=%2B91${Pro.userId.phone}`}  type="button" className="btn btn-white rounded py-2 border" >
                                          <span style={{color:'#058a07'}} className="me-1" >
                                      <svg
  height="20px"
  width="20px"
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 58 58"
  xmlSpace="preserve"
>
  <g>
    <path
      style={{ fill: "#2CB742" }}
      d="M0,58l4.988-14.963C2.457,38.78,1,33.812,1,28.5C1,12.76,13.76,0,29.5,0S58,12.76,58,28.5
		S45.24,57,29.5,57c-4.789,0-9.299-1.187-13.26-3.273L0,58z"
    />
    <path
      style={{ fill: "#FFFFFF" }}
      d="M47.683,37.985c-1.316-2.487-6.169-5.331-6.169-5.331c-1.098-0.626-2.423-0.696-3.049,0.42
		c0,0-1.577,1.891-1.978,2.163c-1.832,1.241-3.529,1.193-5.242-0.52l-3.981-3.981l-3.981-3.981c-1.713-1.713-1.761-3.41-0.52-5.242
		c0.272-0.401,2.163-1.978,2.163-1.978c1.116-0.627,1.046-1.951,0.42-3.049c0,0-2.844-4.853-5.331-6.169
		c-1.058-0.56-2.357-0.364-3.203,0.482l-1.758,1.758c-5.577,5.577-2.831,11.873,2.746,17.45l5.097,5.097l5.097,5.097
		c5.577,5.577,11.873,8.323,17.45,2.746l1.758-1.758C48.048,40.341,48.243,39.042,47.683,37.985z"
    />
  </g>
</svg>

                                          </span> 
                                         Whatsapp
                                        </Link>

</div>
                                   


   {/* Star Rating */}
                                  {/* Product Price */}
                                  <div className="d-none">
                                  <div className="product-price col mt-2 ">
                                    {Pro.salePrice === 0 ? (
                                      <span
                                        className="text-danger"
                                        style={{ color: "red" }}
                                      >
                                        Price On request
                                      </span>
                                    ) : (
                                      <span className="text-danger fs-5">
                                        ₹{Pro.salePrice}
                                        <del className="text-body-secondary ms-1">
                                          <small>₹{Pro.regularPrice}</small>
                                        </del>
                                      </span>
                                    )}

                                  
                                  </div>

                                
                                  </div>
                             


                                       </div>

                                    </div>


                              

<div className="d-flex d-md-none gap-2 pt-2">

    <button type="button" className="btn btn-success rounded me-2 py-2" style={{backgroundColor:'#058a07'}}>
                                        <i className="ri-phone-fill me-2" />
                                          0{Pro.userId.phone}
                                        </button>

                                        <button type="button" className="btn btn-white rounded py-2 border" >
                                          <span style={{color:'#058a07'}} className="me-1" >
                                      <svg
  height="20px"
  width="20px"
  version="1.1"
  id="Capa_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlnsXlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 58 58"
  xmlSpace="preserve"
>
  <g>
    <path
      style={{ fill: "#2CB742" }}
      d="M0,58l4.988-14.963C2.457,38.78,1,33.812,1,28.5C1,12.76,13.76,0,29.5,0S58,12.76,58,28.5
		S45.24,57,29.5,57c-4.789,0-9.299-1.187-13.26-3.273L0,58z"
    />
    <path
      style={{ fill: "#FFFFFF" }}
      d="M47.683,37.985c-1.316-2.487-6.169-5.331-6.169-5.331c-1.098-0.626-2.423-0.696-3.049,0.42
		c0,0-1.577,1.891-1.978,2.163c-1.832,1.241-3.529,1.193-5.242-0.52l-3.981-3.981l-3.981-3.981c-1.713-1.713-1.761-3.41-0.52-5.242
		c0.272-0.401,2.163-1.978,2.163-1.978c1.116-0.627,1.046-1.951,0.42-3.049c0,0-2.844-4.853-5.331-6.169
		c-1.058-0.56-2.357-0.364-3.203,0.482l-1.758,1.758c-5.577,5.577-2.831,11.873,2.746,17.45l5.097,5.097l5.097,5.097
		c5.577,5.577,11.873,8.323,17.45,2.746l1.758-1.758C48.048,40.341,48.243,39.042,47.683,37.985z"
    />
  </g>
</svg>

                                          </span> 
                                         Whatsapp
                                        </button>

</div>
          

                               
                                  {/* Product Price */}
                                  {/* Product Meta */}

                                  {/* Product Meta */}
                                </div>
                                {/* Product Addon */}

                                {/* Product Addon */}
                              </div>
                            </div>
                            {/* Product */}
                          </>
                        );
                      })}

                    {Pro.length === 0 && !isCat && (
                      <div
                        className="container mx-auto my-2 mt-5 py-2 bg-white text-center bg-transparent"
                        style={{
                          height: 193,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <p>No products found for this category.</p>
                      </div>
                    )}

                     {/* Pagination */}
                    {/* 
              <div className="d-flex justify-content-between mt-6">
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#">
                      <i className="ri-arrow-left-s-line me-1" />
                      Prev
                    </a>
                  </li>
                </ul>
                <ul className="pagination">
                  <li className="page-item d-sm-none">
                    <span className="page-link page-link-static">1 / 5</span>
                  </li>
                  <li
                    className="page-item active d-none d-sm-block"
                    aria-current="page"
                  >
                    <span className="page-link">
                      1<span className="visually-hidden">(current)</span>
                    </span>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      2
                    </a>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      3
                    </a>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      4
                    </a>
                  </li>
                  <li className="page-item d-none d-sm-block">
                    <a className="page-link" href="#">
                      5
                    </a>
                  </li>
                </ul>
                <ul className="pagination">
                  <li className="page-item">
                    <a className="page-link" href="#" aria-label="Next">
                      Next
                      <i className="ms-1 ri-arrow-right-s-line" />
                    </a>
                  </li>
                </ul>
              </div> */}

                    <div className="d-none justify-content-between mt-6">
                      <ul className="pagination">
                        <li
                          className={`page-item ${currentPage === 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                          >
                            <i className="ri-arrow-left-s-line me-1"></i>Prev
                          </button>
                        </li>
                      </ul>
                      {/* <ul className="pagination">
          {Array.from({ length: totalPages }, (_, index) => (
            <li className={`page-item ${currentPage === index + 1 ? 'active' : ''}`} key={index}>
              <button className="page-link"  type="button" onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
            </li>
          ))}
        </ul> */}
                      <ul className="pagination">
                        <li
                          className={`page-item ${totalPages === 0 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            aria-label="Next"
                          >
                            Next<i className="ms-1 ri-arrow-right-s-line"></i>
                          </button>
                        </li>
                      </ul>
                    </div>

<div className="border p-3 rounded d-none" ref={loader}  >
  <div className="d-flex gap-2">
 <div
                  className=" skeleton col-md-2 col-6 h-auto"
                  style={{ aspectRatio: "1/1", objectFit: "cover" }}
                />
                <div className="col">
                   <div
                  className=" skeleton col-md-5 col-12  mb-2"
                  style={{ height: "30px" }}
                /> 
                  <div
                  className=" skeleton col-md-3 col-8 mb-2"
                  style={{ height: "30px" }}
                />
                <div
                  className=" skeleton col-md-4 col-10 mb-2"
                  style={{ height: "30px" }}
                />
                 <div
                  className=" skeleton col-md-1 col-4 mb-2"
                  style={{ height: "20px" }}
                />

                <div className="d-md-flex d-none gap-2">
<div
                  className=" skeleton col-1 mb-2"
                  style={{ height: "20px" }}
                />
                <div
                  className=" skeleton col-1 mb-2"
                  style={{ height: "20px" }}
                />
                <div
                  className=" skeleton col-1 mb-2"
                  style={{ height: "20px" }}
                />
                </div>

                       <div className="d-md-flex d-none gap-2 mt-2">
<div
                  className=" skeleton col-2 mb-2"
                  style={{ height: "40px" }}
                />
                <div
                  className=" skeleton col-2 mb-2"
                  style={{ height: "40px" }}
                />
                 
                </div>

                </div>
                
  </div>

  <div className="d-flex d-md-none gap-2 mt-2">
<div
                  className=" skeleton col-6 mb-2"
                  style={{ height: "40px" }}
                />
                <div
                  className=" skeleton col-6 mb-2"
                  style={{ height: "40px" }}
                />
                 
                </div>

             
</div>



{/* 
                    <div ref={loader} style={{ height: "50px", textAlign: "center" }}>
        Loading more...
      </div> */}

                    {/* Pagination */}
                  </div>
                  {/* Product Cards */}
                </div>
                {/* Product Grid */}
                {/* Product List */}

                {/* Product List */}
              </div>

              
                  <div dangerouslySetInnerHTML={{ __html: CatT.description?.replace(/\$\{location\}/g, capitalizedLocation) }} />
                </div>
     
 
  </div>
 
 
            </aside>
            {/* Content */}
          </div>

         

          {Specifications.length !== 0 &&
            Specifications.map((specification, specIndex) => (
              <>
                <section className="my-4 py-4">
                  <h3 className="text-start mb-3">{specification.heading}</h3>
                  <div className="accordion" id={`accordionID` + specIndex}>
                    {specification.labels.map((label, labelIndex) => (
                      <>
                        <div
                          className="accordion-item mb-2 border rounded overflow-hidden bg-light-theme "
                          key={labelIndex}
                        >
                          <div className="accordion-header bg-transparent">
                            <h4
                              style={{ fontSize: 20, fontWeight: 600 }}
                              className="accordion-button h3 collapsed bg-transparent text-white"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#collapseOne${labelIndex}`}
                              aria-expanded="false"
                              aria-controls={`#collapseOne${labelIndex}`}
                            >
                              {label.label?.replace(/\$\{location\}/g, capitalizedLocation)}
                            </h4>
                          </div>
                          <div
                            id={`collapseOne${labelIndex}`}
                            className="accordion-collapse collapse"
                            data-bs-parent={`#accordionID${specIndex}`}
                          >
                            <div className="accordion-body text-white">{label.value?.replace(/\$\{location\}/g, capitalizedLocation)}</div>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                </section>
              </>
            ))}

 

          {/* Product Cards */}
          <div className="container pb-4 pb-lg-10 d-none">
            {/* Heading */}
            <div className="d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
              <h2 className="h3 mb-0 me-2">Recommended Products</h2>
              <div className="ms-n4">
                {/* <a
                className="btn btn-sm btn-link link-info link-hover-primary d-flex align-items-center bg-btn-new"
                href="#"
              >
                View All
                <i className="ri-arrow-right-line ms-1" />
              </a> */}
              </div>
            </div>
            {/* Heading */}
            {/* Product Cards */}
            <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
              {/* Product Card */}
              <Swiper
                breakpoints={{
                  300: {
                    slidesPerView: 2,
                    spaceBetween: 10, // Set the gap between slides for window width <= 400px
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20, // Set the gap between slides for window width <= 768px
                  },
                  992: {
                    slidesPerView: 3,
                    spaceBetween: 25, // Set the gap between slides for window width <= 992px
                  },
                  1200: {
                    slidesPerView: 5,
                    spaceBetween: 20, // Set the gap between slides for window width <= 1200px
                  },
                }}
                pagination={true}
                modules={[Pagination, Navigation]}
                className="swiper-wrapper"
              >
                {isProducts
                  ? Array.from({ length: 7 }).map((_, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="card-1 skeleton"
                        style={{ height: 371, borderRadius: 10 }}
                      ></div>
                    </SwiperSlide>
                  ))
                  : layout.recommended_products && (
                    <>
                      {RProducts.map((product, index) => {
                        const productRatings = ratings.filter(
                          (rating) => rating.productId === product._id
                        );
                        const totalRatings = productRatings.length;
                        const totalRatingValue = productRatings.reduce(
                          (acc, curr) => acc + curr.rating,
                          0
                        );
                        const averageRating =
                          totalRatings > 0
                            ? totalRatingValue / totalRatings
                            : 0;

                        console.log("layout.trending_product.", layout);
                        const myslug = CreateSlug(product.title); // Make sure `data` and `Product` are defined and available in the scope.

                        return (
                          layout.recommended_products.includes(
                            product._id
                          ) && (
                            <>
                              <SwiperSlide key={index}>
                              {/* Product */}
                              <div className="col-sm-6 col-6 col-md-4 px-2 mb-4">
                              <div className="card card-product h-100 bg-light border rounded-4 overflow-hidden bgw-white">
                             
                                {/* Badges */}
                                {/* Buttons */}
                                <div className="product-buttons">
                                  <button
                                    className="btn-product btn-wishlist"
                                    type="button"
                                    data-bs-toggle="button"
                                    title="Add to wishlist"
                                  >
                                    <i className="ri-heart-line" />
                                  </button>
                                  <Link
                                    className="btn-product btn-compare"
                                    href="#"
                                    title="Compare product"
                                  >
                                    <i className="ri-repeat-line" />
                                  </Link>
                                </div>
                                {/* Buttons */}
                                {/* Preview Image */}
                               
                                {/* Preview Image */}
                                <div className="card-body p-2 ">
                                  {/* Product Category */}

                                  {/* <a
                                    className="product-category d-block fs-sm pb-1"
                                    href="#"
                                  >
                                    Smartphones
                                  </a> */}

                                  {/* Product Category */}
                                  {/* Product Title */}
                                  <div className="row justify-content-between w-100 p-0 m-0">
<div className="col">

<h3 className="product-title  mt-2">
                                    <Link to={`/product/${Pro.slug}`}>
                                      {" "}
                                      {Pro.title}{" "}
                                    </Link>
                                  </h3>
</div>
 <div className="col-md-4 text-end">
 <span class="badge btn text-danger bg-white btn-outline-danger">Health</span>

 
 </div>
                                 
                                  </div>

                                  <div className="row justify-content-between w-100 p-0 m-0">
                                    <div className="col">
                                    
                                  
<b className="d-block m-0 p-0">   <i class="ri-microscope-line"></i> {Pro.features.length} Parameters  </b> 
<div>Include</div>
                                    </div>

                                    <div className="col text-md-end fs-8">
                                    
                                  
                                    <b className="d-block m-0 p-0">   <i class="ri-calendar-todo-fill"></i>
                                     Report  </b> 
                                    <div>Same Day</div>
                                      </div>

                                  </div>


                                  {/* Star Rating */}
                                  {/* Product Price */}
                                  <div className="row justify-content-between w-100 p-0 m-0">
                                  <div className="product-price col mt-2 ">
                                    {Pro.salePrice === 0 ? (
                                      <span
                                        className="text-danger"
                                        style={{ color: "red" }}
                                      >
                                        Price On request
                                      </span>
                                    ) : (
                                      <span className="text-danger fs-5">
                                        ₹{Pro.salePrice}
                                        <del className="text-body-secondary ms-1">
                                          <small>₹{Pro.regularPrice}</small>
                                        </del>
                                      </span>
                                    )}

                                  
                                  </div>

                                  <Link className="btn btn-sm btn-primary col-md-1 w-auto mt-2 " to={`/product/${Pro.slug}`}>
Book Now
                                  </Link>
                                  </div>
                             
                                  {/* Product Price */}
                                  {/* Product Meta */}

                                  {/* Product Meta */}
                                </div>
                                {/* Product Addon */}

                                {/* Product Addon */}
                              </div>
                            </div>
                            {/* Product */}
                                {/* Product Cards */}
                              </SwiperSlide>
                            </>
                          )
                        );
                      })}
                    </>
                  )}
              </Swiper>
            </div>
            {/* Product Cards */}
          </div>
          {/* Product Cards */}
        </div>

        {/* Product Category */}
      </div>

      <Footer />
    </>
  );
};

export default Category;
